import React from 'react'
import styles from './styles.module.css'

import { Provider } from 'react-redux';
import ReduxStore from './store';
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';

import InformeAdministracion from './components/informe-administracion-cia';
import DescargaCasos from './components/descarga-casos';

import apiInterceptor from './api/api-interceptor';

import RouterAPP from './routes'
apiInterceptor();

export const ExampleComponent = ({ text }) => {
  return <div className={styles.test}>Example Component: {text}</div>
}
export const InformeAdministracionComponent = () => {
  return (
    <Provider store={ReduxStore()}>
      <InformeAdministracion/>
      {/*<RouterAPP/>*/}
    </Provider>
  )
}
export const DescargaCasosComponent = () => {
  return (
    <Provider store={ReduxStore()}>
      <DescargaCasos/>
      {/* <RouterAPP/>*/}
    </Provider>
  )
}